import { render } from "./TheStart.vue?vue&type=template&id=2c750eca&scoped=true"
import script from "./TheStart.vue?vue&type=script&lang=js"
export * from "./TheStart.vue?vue&type=script&lang=js"

import "./TheStart.vue?vue&type=style&index=0&id=2c750eca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c750eca"]])

export default __exports__